// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"platform-alert_uk-open__fdjhy","grecaptcha-badge":"platform-alert_grecaptcha-badge__MKurW","wrapper":"platform-alert_wrapper__qHpLA","absolute":"platform-alert_absolute__9FKwG","titleWrapper":"platform-alert_titleWrapper__1agaZ","icon":"platform-alert_icon__x3FJn","title":"platform-alert_title__LOvt0","contentWrapper":"platform-alert_contentWrapper__ERnXY"};
    if(module.hot) {
      // 1752653742670
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  